module.exports = __webpack_public_path__ + "static/media/Societe-Immobilier-Transformation-Vaud.702e81c6.jpg";